<template>
  <div style="width: 1000px;margin: 0 auto;height: 100%" class="xh">
    <el-tabs :tab-position="tabPosition" v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane label="入会须知" name="first">
        <div style="padding-left: 50px">
        <div style="font-size: 18px;font-weight: bold;">{{ enternoticetitle }}</div>
<!--        <div style="padding-bottom: 20px;padding-top: 30px;font-size: 14px;text-align: justify;text-indent:2em;line-height: 40px">{{enternoticecontent}}</div>
      -->
        <div class="pa"  style="padding-bottom: 20px;font-size: 14px;text-align: justify" v-html="enternoticecontent"></div>
      </div>
      </el-tab-pane>
      <el-tab-pane label="会员单位" name="second">
        <div style="text-align: left;padding-top: 15px;padding-left: 50px">
          <div v-for="(item, index) in memberList.slice((currentPage-1)*pagesize,currentPage*pagesize)" :key="index"  style="padding-bottom: 120px">
            <router-link :to="{path:'Newsparticulars',query: { id: item.id }}">
              <div>
                <span>
                  <img class="im" :src="item.pic">
                </span>
              </div>
              <div class="pi">
                <span style="font-size: 18px;color: red">{{ item.name }}</span><br>
                <span style="font-size: 14px;">{{ item.introduction_text }}</span>
              </div>
            </router-link>
          </div>
          <!--分页区域-->
          <el-pagination
            style="text-align: center;padding-top: 30px;"
            @size-change="size_change"
            @current-change="current_change"
            :current-page="currentPage"
            :page-sizes="[10,20,30]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="memberList.length
          ">
          </el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="下载专区" name="third">
        <div style="text-align: left;padding-top: 15px;padding-left: 50px">
          <div v-for="(item, index) in xzList" :key="index" style="padding-bottom: 20px">
            <div class="xz">
<!--              <el-button  size="mini" class="filter-item" type="primary" icon="el-icon-download" @click="handleExport(item.id,item.message,'doc')"><span style="font-size: 14px;">{{ item.message_text }}</span></el-button>
            -->
<!--              <el-button  size="mini" class="filter-item" type="primary" icon="el-icon-download" @click="handleExport(item.message)"><span style="font-size: 14px;">{{ item.message_text }}</span></el-button>
              --><div class="pa" style="font-size: 14px;" v-html="item.message"></div>

            </div>
          </div>
          <!--分页区域-->
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Utils from '../../assets/js/util.js';
const axios = require('axios');
export default {
  name: "Admissionnotice",
  data(){
    return{
      total:0,//总条目数
      pagesize:10,//每页显示条目个数
      currentPage:1,//当前页数
      tabPosition: 'left',
      activeName: 'first',
      enternoticetitle:'',
      enternoticecontent:'',
      memberList: [],
      xzList: [],
    }
  },
  mounted(){
    let that=this;
    Utils.$on('demo', function (msg) {
      if(msg == '5-1'){
        that.activeName = "first";
        that.handleClick(that.activeName)
      }else if(msg == '5-2'){
        that.activeName = "second";
        that.handleClick(that.activeName)
      }else if(msg == '5-3'){
        that.activeName = "third";
        that.handleClick(that.activeName)
      }
    });
    let name = sessionStorage.getItem('currentTab')
    // 判断是否存在currentTab，即tab页之前是否被点击切换到别的页面
    if(name){
      this.activeName = name
    }
  },
  beforeRouteLeave(to, from, next){
    // 在离开此路由之后清除保存的状态（我的需求是只需要在当前tab页操作刷新保存状态，路由切换之后不需要保存）
    // 根据个人需求决定清除的时间
    sessionStorage.removeItem('currentTab')
    next()
  },
  created() {
    let a = this.$route.query.act;
    if(a=='first'){
      this.activeName = "first";
      this.handleClick(this.activeName)
    }else if(a=='second'){
      this.activeName = "second";
      this.handleClick(this.activeName)
    }
   // this.enternotice();
   // this.member();
   // this.xz();
  },
  methods: {
    handleClick(tab) {
      console.log(tab)
      if(tab==='first'){
       this.enternotice();
      }else if(tab==='second'){
        this.member();
      }else if(tab==='third'){
        this.xz();
      }
    },
    /*入会须知*/
    enternotice(){
      let params = {}
      this.axios.post('/api/index/enternoticeList',params).then((response) => {
        if(response.data.msg == 'success'){
          this.enternoticetitle = response.data.data.message
          this.enternoticecontent = response.data.data.value
        }
      }).catch(function (error) {
        console.log(error)
      });
    },
    /*协会会员*/
    member(){
      let params = {}
      this.axios.post('/api/index/memberList',params).then((response) => {
        console.log(response)
        if(response.data.msg == 'success'){
          this.memberList = response.data.data.data
        }
      }).catch(function (error) {
        console.log(error)
      });
    },
    /*下载专区*/
    xz(){
      let params = {}
      this.axios.post('/api/index/xzList',params).then((response) => {
        if(response.data.msg == 'success'){
          this.xzList = response.data.data.data
        }
      }).catch(function (error) {
        console.log(error)
      });
    },
    handleTabClick(tab) {
      console.log(tab)
      if(tab.name==='first'){
        this.enternotice();
      }else if(tab.name==='second'){
        this.member();
      }else if(tab.name==='third'){
        this.xz();
      }

      // 点击tab后触发事件，修改显示页面，将状态保存在sessionStorage里面
      sessionStorage.setItem('currentTab', tab.name)
    },
    /*handleExport(url){
      window.open(url)
    },*/
    /*handleExport(id,filename,ty) {
      axios({
        method: 'get',
        url: '/api/index/downloadExcel', // 请求地址
        params: {"id":id}, // 参数
        responseType: 'blob', // 表明返回服务器返回的数据类型
        headers:{
          'Content-type':'pplication/json;charset=UTF-8'
        }
      }).then((res) => {
        let type = '';
        let type2 = [];
        if(ty == 'doc'){
          type = "application/msword"
          type2 = ['.doc','.docx']
        }else if(ty == 'pdf'){
          type = "application/pdf"
          type2 = ['.pdf']
        }else{
          type = "application/vnd.ms-excel"
          type2 = ['.xls',',xlsx']
        }
        const link = document.createElement('a')
        let blob = new Blob([res.data], {type})
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        link.download = filename
        link.type = type2
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
        document.body.removeChild(link)
      }).catch(error=>{
        console.log(error)
      })
    },*/
    //监听 pagesize 改变的事件
    size_change(newSize){
      this.pagesize = newSize
      this.member()
    },
    //监听 页码值 改变的事件
    current_change(newPage){
      this.currentPage = newPage
      this.member()
    },
  }
}
</script>

<style scoped>
.xh >>>.el-tabs__nav-wrap::after {
  position: static !important;
}
.xh >>>.el-tabs__active-bar {
  background-color: transparent !important;
}
.im{
  width: 20%;
  float: left;
  width: 158px;
  height: 79px;
}
.pi{
  float: left;
  width: 75%;
  height: 90px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  text-align: justify;
  text-align: left;
  padding: 0 20px;
  line-height: 27px;
}
a {
  text-decoration: none;
  color: black;
}
.router-link-active {
  text-decoration: none;
}
.pa /deep/ p{
  margin-top: 0px;
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/Admissionnotice.vue